import { buildURL, fetchJSON, fetchPaginatedJSON, fetchWithAuth, paginateQueryParams, simplifyStringRecord, } from "../util/fetch-utils";
// Value that can be passed to GetAllDevicesParams.bbox
// to include all devices in the world.
// Useful to ensure that all devices have a location
// without enforcing any specific region.
export const GET_ALL_DEVICES_BBOX_ALL = [-180, -90, 180, 90];
// The default timeout duration for locating a device
export const DEFAULT_INDICATE_TIMEOUT_S = 30;
export default class VelavuAPIDevices {
    //This method returns all of a customer's devices.
    getAllDevices(params, pagination) {
        //Convert the params to a query object
        const query = {};
        if (params?.category !== undefined) {
            query["category"] = params.category;
        }
        if (params?.siteID !== undefined) {
            query["site_id"] = params.siteID;
        }
        if (params?.geofenceID !== undefined) {
            query["geofence_id"] = params.geofenceID;
        }
        if (params?.bbox !== undefined) {
            query["bbox"] = params.bbox.join(",");
        }
        if (params?.hardware !== undefined) {
            query["hardware"] = params.hardware.join(",");
        }
        if (params?.model !== undefined) {
            query["model"] = params.model;
        }
        if (params?.paired !== undefined) {
            query["paired"] = String(params.paired);
        }
        if (params?.online !== undefined) {
            query["online"] = String(params.online);
        }
        if (params?.configConfirmed !== undefined) {
            query["config_confirmed"] = String(params.configConfirmed);
        }
        if (params?.onlyRegistered !== undefined) {
            query["only_registered"] = String(params.onlyRegistered);
        }
        if (params?.id !== undefined) {
            query["id"] = params.id;
        }
        const url = buildURL("/devices", paginateQueryParams(pagination, query));
        return fetchPaginatedJSON(url);
    }
    //This request allows you to retrieve all stored data for a single device.
    getSpecificDevice(deviceID) {
        return fetchJSON(`/devices/${deviceID}`);
    }
    //This method allows you to query a device by ID or serial code.
    //This is useful for finding a device whose device ID is unknown or
    //seeing if a device can be registered to the user via POST api.velavu.com/devices.
    queryDeviceByIDOrSerial(params) {
        const url = buildURL("/available", simplifyStringRecord(params));
        return fetchJSON(url);
    }
    // This request allows you to register an existing available device to a customer.
    registerAvailableDevice(deviceID, params) {
        const url = buildURL(`/devices/${deviceID}`);
        return fetchJSON(url, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    // This request allows you to register a new device that does not exist in the Velavu backend.
    createNewDevice(params) {
        return fetchJSON("/devices", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This endpoint modifies one or more properties of the device.
    modifySpecificDevice(deviceID, params) {
        return fetchJSON(`/devices/${deviceID}`, {
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
    //This method makes a device become unlocked and sends a reset command to the device.
    // If the device is preprogrammed to a customer, it will self-provision to that customer's account again.
    deleteSpecificDevice(deviceID) {
        return fetchWithAuth(`/devices/${deviceID}`, {
            method: "DELETE",
        });
    }
    //This method reboots device, will only work if the device is currently online
    rebootSpecificDevice(deviceID) {
        return fetchWithAuth(`/devices/${deviceID}/reboot`, {
            method: "POST",
        });
    }
    //This method removes the location from a specific device.
    removeSpecificDeviceLocation(deviceID) {
        return fetchWithAuth(`/devices/${deviceID}/location`, {
            method: "DELETE",
        });
    }
    //This method disables automatic DFU updates for a specific device.
    removeSpecificDeviceDFUChannel(deviceID) {
        return fetchWithAuth(`/devices/${deviceID}/dfu_channel`, {
            method: "DELETE",
        });
    }
    // This method sends a command to the device which triggers a visual or audible indication
    // (e.g. LED flash or buzzer) to help physically locate the device.
    indicateDevice(deviceID, params) {
        return fetchWithAuth(`/devices/${deviceID}/indicate`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(params),
        });
    }
}
//# sourceMappingURL=velavu-api-devices.js.map